// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {
  performanceReportsPlantStatusSubRoute,
  PLANT_STATUS_SUB_PATH
} from '@features/performance-reports'
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {STOPPAGE_ANALYSIS_SUB_PATH, stoppageAnalysisSubRoute} from '@features/stoppage-analysis'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {useFundamentalMuiTheme} from '@hconnect/uikit'
import {usePlantIdFromHierarchyId} from '@hproduce/suite-core'
import {CircularProgress, ThemeProvider} from '@mui/material'
import {Suspense} from 'react'
import {useNavigate, generatePath, RouteObject} from 'react-router'

import {optimizationSpecialistDashboardFeatureTranslations} from '../localization'
import {OptimizationSpecialistPlantDashboard} from '../pages'

const SuiteOptimizationSpecialistDashboard = () => {
  const plantId = usePlantIdFromHierarchyId()
  const navigate = useNavigate()

  if (!plantId) {
    return null
  }

  const navigateToStoppageAnalysis = (equipmentId: string) => {
    void navigate(generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId}))
  }

  return (
    <OptimizationSpecialistPlantDashboard
      plantId={plantId}
      onEquipmentClick={navigateToStoppageAnalysis}
      optimizationSpecialistPerformanceHref={PLANT_STATUS_SUB_PATH}
    />
  )
}

const SuiteOptimizationSpecialistDashboardRouteWrapper = () => {
  return (
    <FeatureTranslationsLoader translations={optimizationSpecialistDashboardFeatureTranslations}>
      <ThemeProvider theme={useFundamentalMuiTheme()}>
        <Suspense fallback={<CircularProgress color="secondary" size={80} />}>
          <SuiteOptimizationSpecialistDashboard />
        </Suspense>
      </ThemeProvider>
    </FeatureTranslationsLoader>
  )
}

export const optimizationSpecialistDashboardRoute: RouteObject = {
  path: '*',
  children: [
    {
      index: true,
      element: <SuiteOptimizationSpecialistDashboardRouteWrapper />
    },
    performanceReportsPlantStatusSubRoute,
    stoppageAnalysisSubRoute
  ]
}
